import React from 'react';

/**
 * Navbar component
 * Displays app title and wallet connection status
 */
function Navbar({ account, onConnect, onDisconnect }) {
  return (
    <nav className="navbar">
      <div className="navbar-content">
        <div className="navbar-brand">
          <span className="logo">✓</span>
          <span className="brand-name">AI Verifier</span>
        </div>

        <div className="navbar-actions">
          {account ? (
            <div className="wallet-info">
              <span className="wallet-address">
                {`${account.slice(0, 6)}...${account.slice(-4)}`}
              </span>
              <button 
                className="btn btn-secondary"
                onClick={onDisconnect}
              >
                Disconnect
              </button>
            </div>
          ) : (
            <button 
              className="btn btn-primary"
              onClick={onConnect}
            >
              Connect Wallet
            </button>
          )}
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
